import getStore from '../store/store';
import type { MailboxInfo } from 'owa-client-types';

export default (mailboxInfo?: MailboxInfo) => {
    return getStore(mailboxInfo).settings.ReliabilityCheck.isPresent === true ? 1 : 0;
};
